import React from 'react';

const GlobalStyles: React.FC = () => (
  <style>{`
    :root {
      --bg-app: var(--color-carbon);
      --bg-panel: var(--color-onyx);
      --border-color: var(--color-zinc-800);
      --text-primary: var(--color-white);
      --text-secondary: var(--color-gray-400);
      --accent-primary: #8b5cf6;
    }

    body {
      background-color: var(--bg-app);
      color: var(--text-primary);
      font-family: 'Inter', sans-serif;
      -webkit-font-smoothing: antialiased;
    }



    /* Cinematic Ambient Light */
    .atelier-ambient {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      pointer-events: none;
      z-index: 0;
      background: radial-gradient(circle at 50% 0%, color-mix(in oklab, var(--color-zinc-600) 8%, transparent), transparent 60%);
    }

    /* Typography */
    h1, h2, h3, .font-heading {
      font-family: 'Outfit', sans-serif !important;
      font-weight: 600;
      letter-spacing: -0.02em;
    }
    
    .font-serif {
       font-family: 'Outfit', sans-serif !important;
    }
    
    .font-screenplay {
       font-family: 'Courier Prime', Courier, monospace !important;
    }

    /* Utility: Glass Panel */
    .glass-panel {
      background: color-mix(in oklab, var(--color-neutral-950) 80%, transparent);
      backdrop-filter: blur(16px);
      -webkit-backdrop-filter: blur(16px);
      border: 1px solid var(--border-color);
    }
    
    /* Utility: Input */
    .atelier-input {
      background: var(--color-onyx);
      border: 1px solid var(--color-zinc-800);
      color: var(--text-primary);
      transition: border-color 0.2s ease;
      border-radius: 8px;
    }
    .atelier-input:focus {
      border-color: var(--color-zinc-600);
      outline: none;
    }

    /* Utility: Button */
    .btn-primary {
      background: var(--color-white);
      color: var(--color-black);
      font-weight: 500;
      border: 1px solid transparent;
      transition: all 0.2s ease;
      border-radius: 8px;
    }
    .btn-primary:hover {
      background: var(--color-zinc-200);
    }

    /* Scrollbar */
    ::-webkit-scrollbar { width: 6px; }
    ::-webkit-scrollbar-track { background: transparent; }
    ::-webkit-scrollbar-thumb { 
      background: var(--color-zinc-800); 
      border-radius: 4px; 
    }
    ::-webkit-scrollbar-thumb:hover { background: var(--color-zinc-700); }
  `}</style>
);

export default GlobalStyles;